import { LazyLoad } from 'app/utils';

export const CommerceBannerSortPage = LazyLoad(
  () => import('./index'),
  (module) => module.CommerceBannerSortPage,
);
